import { render, staticRenderFns } from "./xw.vue?vue&type=template&id=59fd440d&scoped=true"
import script from "./xw.vue?vue&type=script&lang=js"
export * from "./xw.vue?vue&type=script&lang=js"
import style0 from "./xw.vue?vue&type=style&index=0&id=59fd440d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fd440d",
  null
  
)

export default component.exports